import { IPlayer } from '@/data/models'
import i18n from '@/plugins/i18n'

export enum DeviceStatus {
  STATUS_ACTIVE = 'active',
  STATUS_INACTIVE = 'inactive',
  STATUS_UNKNOWN = 'unknown'
}

export const DeviceStatuses = {
  [DeviceStatus.STATUS_ACTIVE]: {
    color: 'success',
    get text() { return i18n.t('status.fieldwiz.active') }
  },
  [DeviceStatus.STATUS_INACTIVE]: {
    color: 'error',
    get text() { return i18n.t('status.fieldwiz.inactive') }
  },
  [DeviceStatus.STATUS_UNKNOWN]: {
    color: 'grey',
    get text() { return i18n.t('status.fieldwiz.unknown') }
  }
}

export interface IDevice {
  id: number;
  serial_number: string;
  device_name: string;
  human_id: string;
  player_id: number;
  player: IPlayer;
  created_at: string;
  updated_at: string;
}
